import { render } from "./AlertError.vue?vue&type=template&id=680f9912"
import script from "./AlertError.vue?vue&type=script&lang=js"
export * from "./AlertError.vue?vue&type=script&lang=js"
script.render = render

export default script